<template>
  <div>
    <!-- ALERTA DE TOPO (aparece só em erro) -->
    <b-alert v-if="topAlert" show :variant="topAlert.variant" class="mb-2" dismissible @dismissed="topAlert = null">
      <feather-icon icon="AlertTriangleIcon" class="mr-50" />
      <span v-html="topAlert.message"></span>
    </b-alert>

    <!-- BODY -->
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <!-- Form -->
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <b-col sm="4">
            <div>
              <b-avatar ref="previewEl" :src="model.logo" :text="model.logo || avatarText(model.name)" size="auto"
                        rounded @click="$refs.refInputEl.click()"
              />
              <b-button class="mt-1" variant="primary" @click="$refs.refInputEl.click()">
                <input ref="refInputEl" type="file" accept="image/*" class="d-none" @input="renderImage">
                <span class="d-none d-sm-inline">Atualizar</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col>
            <i2-form-input v-model="model.document" v-maska="cnpjMaskOptions" label="CNPJ" rules="required|cpfCnpj"
                           name="document" @input="getCompanyInformation"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" md="12">
            <i2-form-input v-model="model.name" rules="required" label="Nome" placeholder="informe o nome do cliente"
                           name="name"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" md="12">
            <i2-form-input v-model="model.domain" label="Dominio da aplicaçao"
                           placeholder="informe o dominio na aplicação " name="name"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <i2-form-vue-select v-model="model.managers" :multiple="true" :options="userList" name="userList"
                                label="Responsáveis"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <i2-form-input v-model="model.corporate_name" label="Razão Social" name="corporate_name" />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <i2-form-address-input v-model="model.address" :value="model.address" />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <div>
      <b-row>
        <b-col sm="12" md="12" class="text-right">
          <!-- Form Actions -->
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="button" class="mr-2"
                    @click="onSubmit"
          >
            <feather-icon icon="SaveIcon" class="mr-50" />
            Salvar
          </b-button>

          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-danger" type="button" @click="onCancel">
            <font-awesome-icon prefix="far" :icon="['far', 'times-circle']" class="mr-50" />
            Cancelar
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { alphaNum, email, required } from '@validations'
import { ValidationObserver } from 'vee-validate'
import I2FormAddressInput from '@/components/i2/forms/elements/I2FormAddressInput.vue'
import { vMaska } from 'maska'

export default {
  name: 'ClientForm',
  directives: {
    Ripple,
    maska: vMaska,
  },
  components: {
    I2FormAddressInput,
    ValidationObserver,
  },
  props: {
    modelUuid: { type: String, required: true },
    isActive: { type: Boolean, required: true },
  },
  data() {
    return {
      required,
      alphaNum,
      email,

      cnpjMaskOptions: {
        // * = alfanumérico (0-9 e A-Z) nas 12 primeiras posições; # = dígito no DV
        mask: '**.***.***/****-##',
        tokens: { '*': { pattern: /[0-9A-Za-z]/, transform: chr => chr.toUpperCase() } },
      },
      topAlert: null,
      cnpjTimer: null,
      cnpjLoading: null,
      lastToastKey: null,
      lastToastTs: 0,
      cnpjProvider: null,

      typesIndexes: [],
      userList: [],
      model: {
        name: '',
        domain: '',
        document: '',
        corporate_name: '',
        managers: [],
        address: {},
        file: '',
        logo: require('@/assets/images/logo/no-logo.png'),
        uuid: null,
      },
    }
  },
  watch: {
    modelUuid(data) {
      if (data === '') return
      this.getUsers(data)
      this.getData(data)
    },
  },
  methods: {
    avatarText(value) {
      if (!value) return ''
      const nameArray = value.split(' ')
      return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
    },
    notifyOnce(type, msg, dedupeWindowMs = 2000) {
      const key = `${type}|${msg}`
      const now = Date.now()
      if (this._lastToastKey === key && (now - this._lastToastTs) < dedupeWindowMs) return
      this._lastToastKey = key
      this._lastToastTs = now
      this.$notify[type](msg)
    },
    httpErrorMessage(e) {
      const status = e?.response?.status || 0
      const data = e?.response?.data

      // 1) tenta JSON usuais
      let msg = data?.data?.message || data?.message || data?.error

      // 2) string/HTML → vira texto puro
      if (!msg && typeof data === 'string') {
        msg = this._plainText(data)
      }

      // 3) mensagens conhecidas
      const text = String(msg || e.message || '').trim()
      if (text.toLowerCase().includes('saldo 0')) {
        return { variant: 'warning', message: 'Saldo 0 no provedor CPF/CNPJ.' }
      }
      if (text.includes('Route [login] not defined') || status === 401 || status === 419) {
        return { variant: 'warning', message: 'Sessão expirada. Faça login novamente.' }
      }

      // 4) fallback por status
      if (!text) {
        if (status === 422) return { variant: 'warning', message: 'Não foi possível consultar este CNPJ.' }
        if (status >= 500) return { variant: 'danger', message: 'Erro interno no provedor. Tente novamente em instantes.' }
      }

      return { variant: status >= 500 ? 'danger' : 'warning', message: text || `Erro ${status}` }
    },
    onSubmit() {
      this.$refs.refFormObserver.validate().then(async success => {
        if (!success) return
        let response = {}
        const data = new FormData()
        const managers = this.model.managers.map(item => item.value)
        data.append('name', this.model.name)
        data.append('domain', this.model?.domain || '')
        data.append('document', this.model.document)
        data.append('corporate_name', this.model.corporate_name)
        data.append('address[postcode]', this.model.address?.postcode)
        data.append('address[address]', this.model.address?.address)
        data.append('address[city]', this.model.address?.city)
        data.append('address[neighborhood]', this.model.address?.neighborhood)
        data.append('address[state]', this.model.address?.state)
        data.append('address[city_code]', this.model.address?.city_code)
        data.append('address[number]', this.model.address?.number)
        data.append('address[complement]', this.model.address?.complement)

        if (this.$refs.refInputEl.files.length === 1) {
          data.append('logo', this.$refs.refInputEl.files[0])
        }
        managers.forEach(item => data.append('managers[]', item))

        if (this.model.uuid) {
          response = await this.$http.post(`clients/${this.model.uuid}?_method=PUT`, data)
        } else {
          response = await this.$http.post('clients', data)
        }
        if (response.error) {
          this.$notify.error(response.error_message)
          return
        }
        this.$notify.success('Cliente salvo com sucesso.')
        this.$refs.refFormObserver.reset()
        this.model = { name: '', uuid: null }
        this.$emit('onModelSave', true)
      })
    },

    async getUsers(uuid) {
      const response = await this.$http.get(`companies/${uuid}/users`)
      this.userList = response.map(item => ({ text: item.name, value: item.uuid }))
    },

    onCancel() {
      this.$emit('onCancel', true)
      this.model = { ...this.blankUser }
      this.$refs.refFormObserver.reset()
    },

    async getData(uuid) {
      const response = await this.$http.get(`clients/${uuid}`)
      if (!response.error) {
        this.model = response
        this.model.managers = response.managers.map(
          user => this.userList.find(us => us.value === user.uuid),
        )
      }
    },

    renderImage() {
      const file = this.$refs.refInputEl.files[0]
      const reader = new FileReader()
      reader.addEventListener(
        'load',
        () => {
          this.model.logo = reader.result
          setTimeout(() => {
            this.$nextTick(() => { this.$forceUpdate() })
          }, 200)
        },
        false,
      )
      if (file) reader.readAsDataURL(file)
    },

    // 👇 pega o provedor ativo uma vez e cacheia
    async getActiveProvider() {
      if (this.cnpjProvider) return this.cnpjProvider
      try {
        const r = await this.$http.get('system-settings/cnpj-provider')
        const root = (r && r.data) ? (r.data.data || r.data) : r
        let settings = root && root.settings
        if (typeof settings === 'string') {
          try { settings = JSON.parse(settings) } catch (_) { /* invalid JSON, keep raw */ }
        }
        this.cnpjProvider = (settings && settings.provider) || root?.provider || null
      } catch (_) {
        this.cnpjProvider = null
      }
      return this.cnpjProvider
    },

    // Tira tags HTML e retorna texto puro (pra quando o back manda página de erro)
    _plainText(html) {
      try {
        const tmp = document.createElement('div')
        tmp.innerHTML = String(html)
        return tmp.textContent?.trim() || tmp.innerText?.trim() || null
      } catch (_) {
        return null
      }
    },

    // 👇 consulta CNPJ e mostra alerta em caso de falha do provedor CPF/CNPJ
    async getCompanyInformation() {
      const doc = this.model.document
      if (!doc || doc.length < 18) return

      // debounce (reinicia a cada digito)
      clearTimeout(this._cnpjTimer)
      this._cnpjTimer = setTimeout(() => this._doCompanyLookup(doc), 350)
    },

    async _doCompanyLookup(doc) {
      // evita consultas paralelas/duplicadas para o mesmo valor
      if (this._cnpjLoading === doc) return
      this._cnpjLoading = doc

      try {
        const res = await this.$http.get('company-search', { params: { document: doc } })

        // Back padronizado: erro vem em 200 com { erro, erroCodigo, ok:false }
        if (res && (res.erro || res.erroCodigo != null || res.ok === false)) {
          const msg = (res.erroCodigo != null) ? `${res.erro} — código ${res.erroCodigo}` : (res.erro || 'Falha na consulta.')
          // Opcional: só avisar quando o provedor for CPF/CNPJ
          try {
            const provRes = await this.$http.get('system-settings/cnpj-provider')
            const root = provRes?.data?.data || provRes?.data || provRes
            let settings = root?.settings
            if (typeof settings === 'string') { try { settings = JSON.parse(settings) } catch (_) { /* invalid JSON, keep raw */ } }
            const provider = settings?.provider || root?.provider || null
            if (!provider || provider === 'cpfcnpj') this.notifyOnce('warning', msg)
          } catch (_) {
            this.notifyOnce('warning', msg)
          }
          return
        }

        // sucesso → preenche
        this.model.name = res.name
        this.model.corporate_name = res.corporate_name
        this.model.address = res.address
      } catch (e) {
        // Se por algum motivo vier 4xx/5xx, ainda assim mostra mensagem única
        const status = e?.response?.status || 0
        const payload = e?.response?.data?.data || e?.response?.data || {}
        const base = payload.erro || payload.message || e.message || 'Falha na consulta.'
        const codigo = payload.erroCodigo ?? payload.code
        const msg = (codigo != null) ? `${base} — código ${codigo}` : base

        try {
          const provRes = await this.$http.get('system-settings/cnpj-provider')
          const root = provRes?.data?.data || provRes?.data || provRes
          let settings = root?.settings
          if (typeof settings === 'string') { try { settings = JSON.parse(settings) } catch (_) { /* invalid JSON, keep raw */ } }
          const provider = settings?.provider || root?.provider || null
          if (!provider || provider === 'cpfcnpj') this.notifyOnce(status >= 500 ? 'error' : 'warning', msg)
        } catch (_) {
          this.notifyOnce(status >= 500 ? 'error' : 'warning', msg)
        }
      } finally {
        if (this._cnpjLoading === doc) this._cnpjLoading = null
      }
    },

  },
}
</script>

<style>
.ql-editor {
  min-height: 200px;
}
</style>
